require(145);
module.exports = require(60).Object.setPrototypeOf;
